import { render, staticRenderFns } from "./image_settings_form.vue?vue&type=template&id=c0a922fc&scoped=true&"
import script from "./image_settings_form.vue?vue&type=script&lang=js&"
export * from "./image_settings_form.vue?vue&type=script&lang=js&"
import style0 from "./image_settings_form.vue?vue&type=style&index=0&id=c0a922fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a922fc",
  null
  
)

export default component.exports